if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        if (!this.elements.viewer) return;

        this.mql = window.matchMedia('(min-width: 750px)');

        if (this.elements.thumbnails) {
          this.elements.viewer.addEventListener(
            'slideChanged',
            debounce(this.onSlideChanged.bind(this), 500)
          );

          this.elements.thumbnails
            .querySelectorAll('[data-target]')
            .forEach((mediaToSwitch) => {
              const button = mediaToSwitch.querySelector('button');
              if (!button) return;

              button.addEventListener(
                'click',
                this.setActiveMedia.bind(
                  this,
                  mediaToSwitch.dataset.target,
                   false
                )
              );
            });
        }

        if (
          this.elements.thumbnails &&
          this.dataset.desktopLayout &&
          this.dataset.desktopLayout.includes('thumbnail') &&
          this.mql.matches
        ) {
          this.removeListSemantic();
        }
      }

      onSlideChanged(event) {
        const currentElement = event.detail.currentElement;
        if (!currentElement || !this.elements.thumbnails) return;

        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        if (!this.elements.viewer) return;

        const activeMedia = this.elements.viewer.querySelector(
          `[data-media-id="${mediaId}"]`
        );
        if (!activeMedia) return;

        this.elements.viewer
          .querySelectorAll('[data-media-id]')
          .forEach((element) => element.classList.remove('is-active'));
        activeMedia.classList.add('is-active');

        if (prepend) {
          const parent = activeMedia.parentElement;
          if (parent) parent.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(
              `[data-target="${mediaId}"]`
            );
            if (activeThumbnail && activeThumbnail.parentElement) {
              activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }

          if (this.elements.viewer.slider && this.elements.viewer.resetPages) {
            this.elements.viewer.resetPages();
          }
        }

        window.setTimeout(() => {
  if (this.elements.thumbnails && activeMedia.parentElement) {
    activeMedia.parentElement.scrollTo({
      left: activeMedia.offsetLeft,
    });
  }

  const isDesktop = this.mql && this.mql.matches;
  const isStackedDesktop =
    this.dataset.desktopLayout === 'stacked' && isDesktop;
  const isMobileViewport = !isDesktop;

  const shouldScrollVertically = isStackedDesktop || isMobileViewport;

  if (shouldScrollVertically) {
    const scrollTarget =
      this.closest('[id^="MainProduct-"]') ||
      this.closest('.shopify-section') ||
      this;

    const rect = scrollTarget.getBoundingClientRect();
    const currentScroll =
      window.pageYOffset || document.documentElement.scrollTop;
    const absoluteTop = rect.top + currentScroll;

    const MIN_SCROLL_DELTA = 24;

    if (Math.abs(currentScroll - absoluteTop) > MIN_SCROLL_DELTA) {
      this.preventStickyHeader();

      scrollTarget.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }
});

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;

        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );
        this.setActiveThumbnail(activeThumbnail);

        if (activeThumbnail) {
          this.announceLiveRegion(
            activeMedia,
            activeThumbnail.dataset.mediaPosition
          );
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));

        const button = thumbnail.querySelector('button');
        if (button) button.setAttribute('aria-current', 'true');

        if (
          this.elements.thumbnails.isSlideVisible &&
          this.elements.thumbnails.isSlideVisible(thumbnail, 10)
        ) {
          return;
        }

        if (this.elements.thumbnails.slider) {
          this.elements.thumbnails.slider.scrollTo({
            left: thumbnail.offsetLeft,
          });
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          '.product__modal-opener--image img'
        );
        if (!image || !this.elements.liveRegion) return;

        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', 'false');
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              '[index]',
              position
            );

          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', 'true');
          }, 2000);
        };

        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        if (window.pauseAllMedia) window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia && deferredMedia.loadContent) {
          deferredMedia.loadContent(false);
        }
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;

        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider || !this.elements.viewer.sliderItems)
          return;

        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute('role', 'presentation')
        );
      }
    }
  );
}
